import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);

  const handle = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in name, email and message.");
      return;
    }
    setBusy(true);
    // We don't have a backend contact endpoint yet; we open the user's
    // mail client so the message still reaches us.
    const body = `Name: ${form.name}%0D%0AEmail: ${form.email}%0D%0A%0D%0A${encodeURIComponent(form.message)}`;
    const mailto = `mailto:hello@instavivah.com?subject=${encodeURIComponent(form.subject || "Enquiry from website")}&body=${body}`;
    window.location.href = mailto;
    toast.success("Opening your email client… we usually reply within one business day.");
    setBusy(false);
  };

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "Contact InstaVivah",
    url: `${typeof window !== "undefined" ? window.location.origin : ""}/contact`,
    contactOption: "HearingImpairedSupported",
    email: "hello@instavivah.com",
  };

  return (
    <div>
      <SEO
        title="Contact Us"
        path="/contact"
        description="Contact the InstaVivah team. Email hello@instavivah.com for support, partnership, or feedback. We reply within one business day."
        keywords="contact InstaVivah, matrimonial support, biodata website help, marriage profile customer care"
        jsonLd={jsonLd}
      />
      <Navbar />

      <header className="sb-page-hero text-center">
        <div className="container">
          <div className="sb-kicker mb-2">We’re here to help</div>
          <h1>Contact us.</h1>
          <p>
            Questions, feedback, partnership ideas — we read every message and
            reply within one business day.
          </p>
        </div>
      </header>

      <main className="container py-5">
        <div className="row g-4">
          <div className="col-lg-5">
            <div className="sb-card h-100">
              <h2 className="h4 mb-3">Reach us directly</h2>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:hello@instavivah.com">
                  hello@instavivah.com
                </a>
              </p>
              <p>
                <strong>Support hours:</strong> Mon–Sat, 10:00 AM – 7:00 PM IST
              </p>
              <p>
                <strong>Response time:</strong> within one business day
              </p>
              <hr />
              <h3 className="h6 mb-2">Quick links</h3>
              <ul className="list-unstyled sb-footer-list">
                <li><Link to="/faq">Frequently Asked Questions</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/refund">Refund Policy</Link></li>
                <li><Link to="/about">About Us</Link></li>
              </ul>
            </div>
          </div>

          <div className="col-lg-7">
            <form className="sb-contact-card" onSubmit={submit} data-testid="contact-form">
              <h2 className="h4 mb-4">Send us a message</h2>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Your name</label>
                  <input
                    className="form-control"
                    value={form.name}
                    onChange={(e) => handle("name", e.target.value)}
                    data-testid="contact-name"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={form.email}
                    onChange={(e) => handle("email", e.target.value)}
                    data-testid="contact-email"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Subject</label>
                  <input
                    className="form-control"
                    value={form.subject}
                    onChange={(e) => handle("subject", e.target.value)}
                    data-testid="contact-subject"
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Message</label>
                  <textarea
                    className="form-control"
                    rows="5"
                    value={form.message}
                    onChange={(e) => handle("message", e.target.value)}
                    data-testid="contact-message"
                    required
                  />
                </div>
                <div className="col-12">
                  <button className="btn btn-primary" disabled={busy} data-testid="contact-submit">
                    {busy ? "Sending…" : "Send message"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
